<fin-seat-map-view
  [flight]="flight"
  [passengers$]="passengers$"
  [flightIsActive$]="flightIsActive$"
  [includedSeats]="includedSeats"
  [availability$]="availability$"
  [cartOrOrder$]="cartOrOrder$"
  [canClearSeats]="canClearSeats"
  [preSelectedPax$]="preSelectedPax$"
  [ancillaryLoader$]="ancillaryLoader$"
  [skipScroll]="skipScroll"
  [notEligibleWhenCheckInClosed]="notEligibleWhenCheckInClosed"
  [purchaseFlow]="purchaseFlow"
  (retrySeatmap)="retrySeatmap.emit(flight)"
  (changeSeats)="seatSelected($event)"
  (isReassigningSeats)="emitFinishedReassigningSeats()"
  [contextCategory]="contextCategory"
/>
